import type { IconGlyph } from '../icon';

import { iconSettingsThick } from './settings-thick';

/**
 * Tractie `settings` glyph (medium, 24×24).
 *
 * Source: `@tractie/icons` v1.5.0, `dist/jsx/m/settings.jsx`.
 * Verbatim copy of the SVG `d` attributes, 2 paths in source order.
 */
export const iconSettings: IconGlyph = {
  name: 'settings',
  path: [
    'M12 9c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3m0 5c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2',
    'M22 13.53v-3.05l-2.87-.82-.43-1.03 1.45-2.6-2.16-2.19-2.61 1.47-1.02-.42-.83-2.88h-3.05l-.83 2.87-.99.4-2.63-1.44-2.2 2.2 1.43 2.63-.39.94-2.88.85v3.1l2.88.85.39.94-1.44 2.64 2.2 2.19 2.63-1.43.95.4.84 2.88h3.11l.84-2.88.99-.41 2.61 1.45 2.16-2.16-1.45-2.61.43-1.02 2.87-.83Zm-3.09 4.28-1.1 1.1-2.37-1.31-1.87.79-.76 2.62H11.2l-.76-2.62-1.83-.76-2.39 1.31-1.14-1.13 1.32-2.4-.77-1.82-2.62-.77v-1.6l2.62-.77.75-1.82-1.31-2.39L6.21 5.1 8.6 6.4l1.87-.76.75-2.61h1.55l.75 2.62 1.92.8 2.37-1.33 1.1 1.11-1.31 2.36.79 1.93 2.61.74v1.55l-2.61.75-.79 1.92 1.31 2.37Z',
  ],
  selected: iconSettingsThick,
};
